import {combineReducers } from 'redux';
import { signUp } from './modules/common/reducers';
import { smData, userDetails } from './modules/setup/reducers';

/**
 * Combines all the individual reducers and creates a single data source
 */
const rootReducer = combineReducers({
	signUp,
	smData,
	userDetails
});

export default rootReducer;
